import { defineMessages, FormattedMessage } from '@faceup/localization'
import { TextUrlfy } from '@faceup/ui'
import { ChannelType } from '@faceup/utils'
import { type ReactNode, useMemo } from 'react'
import { type FragmentType, getFragmentData, graphql } from '../../../__generated__'
import { useCustomValues } from '../../../hooks/useCustomValues'

const messages = defineMessages(
  'followUp.pages.reportSent.hooks.useReportSentData',
  [
    ChannelType.AutomatedHotline,
    ChannelType.LiveHotline,
    ChannelType.AiHotline,
    ChannelType.ReportingSystem,
  ] as const,
  {
    [ChannelType.AutomatedHotline]:
      'We received the case in order. We will investigate it as soon as possible and respond to you.',
    [ChannelType.LiveHotline]:
      'We received the case in order. We will investigate it as soon as possible and respond to you.',
    [ChannelType.AiHotline]:
      'We received the case in order. We will investigate it as soon as possible and respond to you.',
    [ChannelType.ReportingSystem]:
      'We received the case in order. We will investigate it as soon as possible and respond to you.',
  }
)

const fragments = {
  useReportSentData_publicReportSource: graphql(`
    fragment useReportSentData_publicReportSource on PublicReportSource {
      id
      sourceType
      config {
        ... on FormReportSourceConfiguration {
          id
          reportSentDescription
        }
      }
    }
  `),
}

export const useReportSentData = (
  _reportSource: FragmentType<typeof fragments.useReportSentData_publicReportSource>
) => {
  const reportSource = getFragmentData(
    fragments.useReportSentData_publicReportSource,
    _reportSource
  )
  const customValues = useCustomValues()
  const config =
    reportSource.config.__typename === 'FormReportSourceConfiguration' ? reportSource.config : null

  const reportSentDescription: ReactNode = useMemo(() => {
    if (customValues?.description) {
      return <TextUrlfy text={customValues.description} />
    }
    if (config?.reportSentDescription) {
      return <TextUrlfy text={config.reportSentDescription} />
    }
    if (reportSource.sourceType === ChannelType.Survey) {
      return null
    }
    return <FormattedMessage message={messages[reportSource.sourceType]} />
  }, [config?.reportSentDescription, reportSource.sourceType, customValues?.description])

  return {
    reportSentDescription,
  }
}
